<template>
  <div class="bg-white/90 dark:bg-gray-900/80 rounded-xl p-4">
    <div class="animate-pulse flex flex-col gap-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="h-6 w-6 rounded-full bg-gray-200 dark:bg-gray-700"></div>
          <div class="h-4 w-24 rounded-md bg-gray-200 dark:bg-gray-700"></div>
        </div>
        <div class="h-4 w-16 rounded-md bg-gray-200 dark:bg-gray-700"></div>
      </div>
      <div class="h-7 w-full rounded-md bg-gray-200 dark:bg-gray-700 mt-1"></div>
    </div>
  </div>
</template>